import React, { createContext, useContext, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

type Notification = {
  message: string;
  severity?: 'success' | 'error' | 'info' | 'warning';
};

const NotificationContext = createContext<{ show: (n: Notification) => void } | null>(null);

export const useNotifier = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotifier must be used within NotifierProvider');
  return ctx;
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const NotifierProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [notif, setNotif] = useState<Notification>({ message: '', severity: 'info' });

  const show = (n: Notification) => {
    setNotif(n);
    setOpen(true);
  };

  return (
    <NotificationContext.Provider value={{ show }}>
      {children}
      <Snackbar open={open} autoHideDuration={5000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={() => setOpen(false)} severity={notif.severity || 'info'} sx={{ width: '100%' }}>
          {notif.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export default NotifierProvider;
